import BaseForm from '../base';
import { LatLongColumnsComponent, TwoColumnsComponent } from '../components';
export class StrobeSirenForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            new LatLongColumnsComponent({ validate: { required: true } }),
            {
                label: 'Local IP',
                key: 'ip',
                type: 'textfield',
            },
            new TwoColumnsComponent({ key: 'credentials' }, {
                label: 'Username',
                key: 'username',
                type: 'textfield',
            }, {
                label: 'Password',
                key: 'password',
                type: 'customPassword'
            }),
        ];
    }
}
